import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import $ from 'jquery';
import FormControl from 'react-bootstrap/FormControl'



function AddCommentModal(props) {
 
   
    var modalTitle = "Add Comments";
      
    const handleClose = (e) => {
        props.handleClose();
    }

    const confirmMethod = (e) => {
        var comment = $("#comments").val();
        if (comment !== props.stateProps.comments) {
            props.UpdateComments();
            }
        props.handleClose();
    }
   
   
   
    return (
       
        <Modal show={props.stateProps.showaddcommentmodal} onHide={handleClose} style={{opacity: 1}} >
            <Modal.Header closeButton>
                <Modal.Title>{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Comments
                <div>
                    <FormControl as="textarea" id="comments" aria-label="With textarea" defaultValue={props.stateProps.comments} />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cancel
          </Button>
                <Button variant="primary" onClick={confirmMethod} >
                    Ok
          </Button>
            </Modal.Footer>
        </Modal>

     
    );
  
}

export default AddCommentModal;
